import { render, staticRenderFns } from "./RestBreakConfirmation.vue?vue&type=template&id=2b41434b&"
import script from "./RestBreakConfirmation.vue?vue&type=script&lang=js&"
export * from "./RestBreakConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports